import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {rulesMap} from 'go/components/rules/rules';
import {DynamicTextBoxField as _DynamicTextBoxField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicTextBoxField';

export const DynamicTextBoxField = (props) => (
  <_DynamicTextBoxField {...props} {...{rulesMap}} />
);
export default connectWithCore(DynamicTextBoxField);
